import styled, { css } from 'styled-components';

export const Container = styled.div<{ $isDragging: boolean }>`
  width: 100%;

  .ant-upload-btn {
    padding: 10px 8px !important;
    border-radius: 8px !important;

    @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
      padding: 12px !important;
    }
  }

  .ant-upload-drag {
    border: 1px dashed ${({ theme }) => theme.colors.black4} !important;
    border-radius: 8px !important;
    background-color: ${({ theme }) => theme.colors.black1} !important;
    padding: 0 !important;
    transition: all 0.3s ease !important;

    ${({ $isDragging }) =>
      $isDragging &&
      css`
        border-color: ${({ theme }) => theme.colors.green6} !important;
        background-color: ${({ theme }) => theme.colors.green1} !important;
      `}

    &:hover {
      border-color: ${({ theme }) => theme.colors.green6} !important;
      background-color: ${({ theme }) => theme.colors.green1} !important;
    }
  }

  .ant-upload-drag-container {
    display: flex;
    flex-direction: row;
    align-items: center;
    justify-content: flex-start;
    padding: 0 8px;
    gap: 8px;
    min-height: 32px;

    @media (min-width: ${({ theme }) => theme.mediaQueries.md}) {
      padding: 0 12px;
      min-height: 32px;
    }
  }
`;
